import { z } from "zod";
/**
 * Schema für die von der KI erwartete strukturierte Antwort (Aufgabenstellung Abschnitt 8).
 * Wird sowohl für die OpenAI response_format json_schema als auch für die
 * serverseitige Validierung nach dem Parsen verwendet.
 */
export const aiAssignmentSchema = z.object({
    topicId: z.string().min(1),
    percentage: z.number().min(0).max(100),
    confidence: z.number().min(0).max(1),
    reason: z.string().min(1),
});
export const aiUnknownTopicSuggestionSchema = z.object({
    suggestedName: z.string().min(1),
    reason: z.string().min(1),
});
export const aiAnalysisResultSchema = z.object({
    projectId: z.string().min(1),
    summary: z.string().min(1),
    assignments: z.array(aiAssignmentSchema).min(1),
    overallConfidence: z.number().min(0).max(1),
    warnings: z.array(z.string()).default([]),
    unknownTopicSuggestions: z.array(aiUnknownTopicSuggestionSchema).default([]),
});
/** Toleranz beim Prüfen der 100%-Summe (Rundungsfehler von Sprachmodellen). */
export const AI_PERCENTAGE_SUM_TOLERANCE = 1.0;
export function validateAiAssignmentSum(assignments) {
    const sum = assignments.reduce((acc, a) => acc + a.percentage, 0);
    if (Math.abs(sum - 100) > AI_PERCENTAGE_SUM_TOLERANCE) {
        return { code: "SUM_NOT_100", message: `Summe der Prozentwerte ist ${sum.toFixed(1)}%, erwartet 100%.` };
    }
    return null;
}
export const AI_MODES = [
    "single",
    "selected",
    "all_unclassified",
    "low_confidence",
    "reanalyze",
    "all_classified",
];
export const AI_JOB_STATUSES = ["pending", "running", "completed", "failed", "cancelled"];
// Personen-Analogon zu AI_MODES - kein "low_confidence" (eine Person hat keine "Konfidenz", bevor
// sie das erste Mal analysiert wurde), siehe AiPersonJobMode in schema.prisma.
export const AI_PERSON_MODES = ["single", "selected", "all_unassigned", "reanalyze", "all_assigned"];
export const AI_PROVIDERS = ["openai", "azure-openai", "mock"];
